import * as React from "react";

interface Props {}

export const BlogSvg = (props: Props) => (
	<svg
		width={15}
		height={15}
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={7.5} cy={7.5} r={7.5} fill="url(#paint0_linear_1_5668)" />
		<g clipPath="url(#clip0_1_5668)">
			<path
				d="M10.2475 5.54688H9.66154L5.92456 5.15625L4.948 6.13281L4.75269 10.625H10.0522C10.4818 10.625 10.8334 10.2734 10.8334 9.84375V6.13281C10.8334 5.80859 10.5717 5.54688 10.2475 5.54688Z"
				fill="#98A2FF"
			/>
			<path
				d="M9.66154 4.76562C9.66154 4.55078 9.48576 4.375 9.27091 4.375H4.55737C4.34253 4.375 4.16675 4.55078 4.16675 4.76562V10.0391C4.16675 10.3696 4.43647 10.625 4.75269 10.625C5.07692 10.625 5.33862 10.3633 5.33862 10.0391V6.13281C5.33862 5.80859 5.60033 5.54688 5.92456 5.54688H9.66154V4.76562ZM6.13289 8.86719C6.13289 8.97514 6.22025 9.0625 6.32821 9.0625H9.84383C9.95179 9.0625 10.0391 8.97514 10.0391 8.86719C10.0391 8.75923 9.95179 8.67188 9.84383 8.67188H6.32821C6.22025 8.67188 6.13289 8.75923 6.13289 8.86719ZM9.84383 9.45312H6.32821C6.22025 9.45312 6.13289 9.54048 6.13289 9.64844C6.13289 9.75639 6.22025 9.84375 6.32821 9.84375H9.84383C9.95179 9.84375 10.0391 9.75639 10.0391 9.64844C10.0391 9.54048 9.95179 9.45312 9.84383 9.45312ZM9.1671 6.94229C9.14421 6.87152 9.08318 6.82003 9.00955 6.80935L8.53424 6.74012L8.32137 6.30944C8.25576 6.1763 8.0368 6.17612 7.97117 6.30964L7.7587 6.74013L7.28339 6.80936C7.20977 6.82004 7.14873 6.87154 7.12584 6.9423C7.10295 7.01288 7.12202 7.09051 7.17543 7.14238L7.51913 7.4777L7.43788 7.95091C7.42529 8.02415 7.45543 8.09816 7.51571 8.14203C7.57508 8.18507 7.6547 8.19181 7.72132 8.15672L8.14628 7.93337L8.57162 8.15672C8.63723 8.19124 8.71696 8.1859 8.77723 8.14184C8.8375 8.09816 8.86763 8.02415 8.85506 7.95091L8.77381 7.4777L9.1175 7.14238C9.17091 7.09049 9.18999 7.01286 9.1671 6.94229Z"
				fill="white"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_1_5668"
				x1={9.54468}
				y1={14.2874}
				x2={6.16609}
				y2={0.743978}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0019FF" />
				<stop offset={1} stopColor="#717FFF" />
			</linearGradient>
			<clipPath id="clip0_1_5668">
				<rect
					width={6.66667}
					height={6.66667}
					fill="white"
					transform="translate(4.16675 4.16666)"
				/>
			</clipPath>
		</defs>
	</svg>
);
